import { FunnelIcon } from '@heroicons/react/24/solid';
import React from 'react';

const FilterButtonSkeleton = () => {
  return (
    <div
      className="m-auto ml-4 flex h-10 w-10 animate-pulse items-center rounded-lg bg-gray-300 dark:bg-gray-600"
      aria-hidden="true"
    >
      <FunnelIcon className="m-auto h-5 w-5 text-teal-500 dark:text-teal-200" />
    </div>
  );
};

export default FilterButtonSkeleton;
